var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-reamaze-embed":"contact","data-reamaze-embed-form-id":"25310"}})}
var staticRenderFns = []

export { render, staticRenderFns }